exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_users_303JxmiXyrMQf-HtrYRN8y {\n  width: 100%;\n  position: relative;\n  float: left;\n}\n\n.IA_users_303JxmiXyrMQf-HtrYRN8y h1 {\n  float: left;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_users": "IA_users_303JxmiXyrMQf-HtrYRN8y"
};